/**
 * bunny.net Stream Analytics API
 * Metrics come from data sources with different prerequisites: some need only standard CDN request logging, others need CMCD v1 query-string enrichment or a CMCD v2 player beacon - see each endpoint\'s description for which. If its required source isn\'t enabled, an endpoint returns empty/zero results, not an error.
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { HttpClient, HttpContext, HttpEvent, HttpHeaders, HttpParameterCodec, HttpParams, HttpResponse } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';

import { Observable } from 'rxjs';

import { Configuration } from '../configuration';
import { CustomHttpParameterCodec } from '../encoder';
// @ts-ignore
import { StreamAnalyticsCmcdPostPullZoneIdParameter } from '../model/stream-analytics-cmcd-post-pull-zone-id-parameter';
// @ts-ignore
import { ViewingHeatmapResponse } from '../model/viewing-heatmap-response';
// @ts-ignore
import { BASE_PATH } from '../variables';

export interface StreamAnalyticsV1PullZoneIdContentHeatmapGetRequestParams {
  pullZoneId: StreamAnalyticsCmcdPostPullZoneIdParameter;
  videoId: string;
  from: string;
  to: string;
  /** Restrict to one or more country codes (repeatable) - matches any of the given values. */
  countryCode?: string[];
  /** Restrict to one or more browsers (repeatable) - matches any of the given values. */
  browser?: string[];
  /** Restrict to one or more operating systems (repeatable) - matches any of the given values. */
  os?: string[];
  /** Restrict to one or more device categories (repeatable) - matches any of the given values. */
  deviceCategory?: string[];
  /** Restrict to one or more bot categories (repeatable) - matches any of the given values. Use \&#39;Human\&#39; for non-bot traffic; every value returned by /audience/bot is accepted here. */
  botCategory?: string[];
}

@Injectable({
  providedIn: 'root',
})
export class ContentService {
  protected basePath = 'https://mc-cwlfiqxct9.bunny.run';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration,
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
      if (firstBasePath != undefined) {
        basePath = firstBasePath;
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  // @ts-ignore
  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === 'object' && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        (value as any[]).forEach((elem) => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
        } else {
          throw Error('key may not be null if value is Date');
        }
      } else {
        Object.keys(value).forEach((k) => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k)));
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error('key may not be null if value is not object or array');
    }
    return httpParams;
  }

  /**
   * Viewing heatmap for a single VOD asset
   * Viewing density across a single VOD asset, grouped by position - the literal segment index, a stable, absolute position in the packaged file. Live is not currently supported. Available only for data from the last 14 days. Can be narrowed to a single country/browser/OS/device category/bot category with the corresponding filter parameter.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public streamAnalyticsV1PullZoneIdContentHeatmapGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdContentHeatmapGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<ViewingHeatmapResponse>;
  public streamAnalyticsV1PullZoneIdContentHeatmapGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdContentHeatmapGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<ViewingHeatmapResponse>>;
  public streamAnalyticsV1PullZoneIdContentHeatmapGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdContentHeatmapGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<ViewingHeatmapResponse>>;
  public streamAnalyticsV1PullZoneIdContentHeatmapGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdContentHeatmapGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const pullZoneId = requestParameters?.pullZoneId;
    if (pullZoneId === null || pullZoneId === undefined) {
      throw new Error('Required parameter pullZoneId was null or undefined when calling streamAnalyticsV1PullZoneIdContentHeatmapGet.');
    }
    const videoId = requestParameters?.videoId;
    if (videoId === null || videoId === undefined) {
      throw new Error('Required parameter videoId was null or undefined when calling streamAnalyticsV1PullZoneIdContentHeatmapGet.');
    }
    const from = requestParameters?.from;
    if (from === null || from === undefined) {
      throw new Error('Required parameter from was null or undefined when calling streamAnalyticsV1PullZoneIdContentHeatmapGet.');
    }
    const to = requestParameters?.to;
    if (to === null || to === undefined) {
      throw new Error('Required parameter to was null or undefined when calling streamAnalyticsV1PullZoneIdContentHeatmapGet.');
    }
    const countryCode = requestParameters?.countryCode;
    const browser = requestParameters?.browser;
    const os = requestParameters?.os;
    const deviceCategory = requestParameters?.deviceCategory;
    const botCategory = requestParameters?.botCategory;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (videoId !== undefined && videoId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>videoId, 'videoId');
    }
    if (from !== undefined && from !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>from, 'from');
    }
    if (to !== undefined && to !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>to, 'to');
    }
    if (countryCode) {
      countryCode.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'countryCode');
      });
    }
    if (browser) {
      browser.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'browser');
      });
    }
    if (os) {
      os.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'os');
      });
    }
    if (deviceCategory) {
      deviceCategory.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'deviceCategory');
      });
    }
    if (botCategory) {
      botCategory.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'botCategory');
      });
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (BunnyJwt) required
    localVarCredential = this.configuration.lookupCredential('BunnyJwt');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (BunnyAccessKey) required
    localVarCredential = this.configuration.lookupCredential('BunnyAccessKey');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('AccessKey', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/stream/analytics/v1/${this.configuration.encodeParam({ name: 'pullZoneId', value: pullZoneId, in: 'path', style: 'simple', explode: false, dataType: 'StreamAnalyticsCmcdPostPullZoneIdParameter', dataFormat: 'uint64' })}/content/heatmap`;
    return this.httpClient.request<ViewingHeatmapResponse>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }
}
